export enum OrderTabsNames {
    COMMENTS = "orders.tabs.comments",
    DETAILS = "orders.tabs.details",
    HISTORY = "orders.tabs.history",
    ADDITIONAL_INFO = "orders.tabs.additionalInfo",
    SMS_HISTORY = "orders.tabs.smsHistory"
}